import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaRegFileExcel } from 'react-icons/fa6';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import Loading from '../../components/Loading';
import NumberFormat from '../../components/NumberFormat';
import AddDepense from './AddDepense';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';
import { FaBan, FaCheck, FaCircle, FaEye } from 'react-icons/fa';
import VoirDepense from './VoirDepense';
import Select from 'react-select';
import AddDistDepense from './AddDistDepense';


const Depenses = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [depenses, setDepenses] = useState([]);
    const [showAddDepense, setShowAddDepense] = useState(false);
    const [showAddDetail, setShowDetail] = useState(false);
    const [selectedDepense, setSelectedDepense] = useState(null);
    const { token, setToken, user } = useStateContext();
    const [categories, setCategories] = useState([]);
    const [selectedCategorie, setSelectedCategorie] = useState(null);
    const [inputValueCategorie, setValueCategorie] = useState('');
    const [caisses, setCaisses] = useState([]);
    const [selectedCaisse, setSelectedCaisse] = useState(null);
    const [inputValueCaisse, setValueCaisse] = useState('');
    const [showAddDistDepense, setShowAddDistDepense] = useState(false);
    const tableRef = useRef();
    const [req, setReq] = useState({
        DateDebut: '',
        DateFin: '',
        caisse: '',
        categorie: '',
    });
    const navigate = useNavigate();

    const supprimer = (depense) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/depense/' + depense.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getDepenses();
                    }).catch(err => {
                        const response = err.response;
                        if (response.status === 401) {
                            setToken(null);
                        }
                        else {
                            if (response.status === 422) {
                                setErrors(response.data.errors);
                                setLoading(false);
                                toast.error('Une Erreur est survenue', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            } else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }

                        }
                    })
            }
        });
    }

    useEffect(() => {
        if (user.role != null && (user.role.name === 'admin' || user.role.name === 'controleur' || user.role.name === 'dist')) {
            getCategories();
            getCaisses();
        }
    }, [])

    const handleInputChangeCategorie = value => {
        setValueCategorie(value);
    };

    // handle selection


    // handle selection
    const handleChangeCategorie = value => {
        setSelectedCategorie(value);
        setReq({ ...req, categorie: value.id });

    }

    const handleInputChangeCaisse = value => {
        setValueCaisse(value);
    };

    // handle selection


    // handle selection
    const handleChangeCaisse = value => {
        setSelectedCaisse(value);
        setReq({ ...req, caisse: value.id });

    }
    const closeAddDepense = () => {
        setShowAddDepense(false);
    }

    const closeShowDepense = () => {
        setShowDetail(false);
        setSelectedDepense(null);
    }
    const getCategories = () => {
        axiosClient.get('/categories')
            .then((data) => {
                setCategories(data.data.categories);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une Erreur est survenue', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const getCaisses = () => {
        axiosClient.get('/softCaisses')
            .then((data) => {
                setCaisses(data.data.caisses);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const getDepenses = () => {
        setLoading(true);
        axiosClient.get('/depenses?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin + '&caisse=' + req.caisse + '&categorie=' + req.categorie)
            .then(response => {
                setDepenses(response.data.depenses);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const valider = (depense) => {
        axiosClient.put('/depense/' + depense.id)
            .then((data) => {
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const annuler = (depense) => {
        axiosClient.put('/annulerDepense/' + depense.id)
            .then((data) => {
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const addDist = () => {
        if (selectedCaisse === null) {
            Swal.fire({
                title: "Alert",
                text: "Veillez sélectionner une caisse!",
                icon: "warning",
                confirmButtonColor: "#2196F3",
                confirmButtonText: "OK!",
            });
        } else {
            setShowAddDistDepense(true);
        }
    }
    const closeAddDistDepense = () => {
        setShowAddDistDepense(false);

    }


    return (
        <>
            <Header title="Dépenses" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>
                <Input label="Date debut" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
                <Input label="Date fin" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />
                {user.role && (user.role.name === 'admin' || user.role.name === 'controleur' || user.role.name === 'dist') ?
                    <>
                        <div className="flex-col w-full">
                            <label className="block text-sm font-medium leading-6 text-gray-900">Catégorie <span className='text-red-500'> *</span></label>
                            <Select className='mt-1 outline-1 ' placeholder="Categorie" cacheOptions defaultOptions value={selectedCategorie} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={categories} onInputChange={handleInputChangeCategorie} onChange={handleChangeCategorie} />
                        </div>
                        <div className="flex-col w-full">
                            <label className="block text-sm font-medium leading-6 text-gray-900">Caisse <span className='text-red-500'> *</span></label>
                            <Select className='mt-1 outline-1 ' placeholder="Caisse" cacheOptions defaultOptions value={selectedCaisse} getOptionLabel={e => e.nom} getOptionValue={e => e.id} options={caisses} onInputChange={handleInputChangeCaisse} onChange={handleChangeCaisse} />
                        </div>
                    </>
                    :
                    <></>
                }
                <div className=' flex gap-2 mt-8'>
                    <Button onClick={() => getDepenses()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                    <DownloadTableExcel
                        filename="Depenses"
                        sheet="depenses"
                        currentTableRef={tableRef.current}
                    >
                        <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />

                    </DownloadTableExcel>
                </div>
            </div>
            {
                user.role && user.role.name === 'caissier' ? <div className="flex my-4">
                    <Button onClick={() => setShowAddDepense(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                </div>
                    : <></>
            }
            {
                user.role && (user.role.name === 'admin' || user.role.name === 'controleur' || user.role.name === 'dist') ? <div className="flex my-4">
                    <Button onClick={() => addDist()} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                </div>
                    : <></>
            }
            <div className="flex my-2">
                <h1 className='text-red-500 font-bold'>Total: <NumberFormat valeur={depenses.reduce((n, { montant }) => n + parseFloat(montant), 0)} /> MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Caisse</th>
                            <th>Catégorie</th>

                            <th>Bénéficiaire</th>
                            <th>Montant</th>
                            <th>État</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="6"><Loading /></td></tr></tbody> :
                        <tbody className='text-sm'>
                            {depenses.map(o => (
                                <tr>
                                    <td>{o.dateDepense}</td>
                                    <td>{o.caisse}</td>
                                    <td>{o.categorie.libelle}</td>

                                    <td>{o.beneficiaire}</td>
                                    <td>{o.montant}</td>
                                    {
                                        o.valide === false ?
                                            <div className='flex justify-center items-center text-lg text-orange-500'>
                                                <FaCircle />
                                            </div>
                                            :
                                            <div className='flex justify-center items-center text-lg text-lime-500'>
                                                <FaCircle />
                                            </div>
                                    }
                                    <td>
                                        <div className="flex gap-2">
                                            {user.role && (user.role.name === 'admin') ?
                                                <>
                                                    {o.valide === false ?
                                                        <ActionButton onClick={() => {
                                                            valider(o);
                                                        }} color="bg-green-500" icon={<FaCheck />} textColor="text-white" title="Valider" />
                                                        :
                                                        <ActionButton onClick={() => {
                                                            annuler(o);
                                                        }} color="bg-yellow-500" icon={<FaBan />} textColor="text-white" title="Annuler" />
                                                    }

                                                </>
                                                :
                                                <></>
                                            }
                                            {user.role && (user.role.name === 'controleur') ?
                                                <>
                                                    {o.valide === false ?
                                                        <>
                                                            <ActionButton onClick={() => {
                                                                valider(o);
                                                            }} color="bg-green-500" icon={<FaCheck />} textColor="text-white" title="Valider" />

                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                    
                                                </>
                                                :
                                                <></>
                                            }
                                            <ActionButton onClick={() => {
                                                setSelectedDepense(o);
                                                setShowDetail(true);
                                            }} color="bg-green-500" icon={<FaEye />} textColor="text-white" title="Voir" />
                                            {o.valide === false ?
                                                <ActionButton onClick={() => { supprimer(o) }} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" />
                                                : <></>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))

                            }
                        </tbody>
                    }

                </table>
            </div>
            {
                showAddDepense ? <AddDepense onClose={closeAddDepense} /> : <></>
            }
            {
                showAddDetail ? <VoirDepense onClose={closeShowDepense} depense={selectedDepense} /> : <></>
            }
            {
                showAddDistDepense ? <AddDistDepense cai={selectedCaisse} onClose={closeAddDistDepense} /> : <></>
            }

        </>
    )
}

export default Depenses